import React from "react";
import {useTranslation} from "react-i18next";
import ReportingInfoTooltip from "../../../../../components/ReportingInfoTooltip.jsx";

export function campaignOrderBasisCopy(t, isMarketing) {
    if (isMarketing) {
        return {
            short: t("reporting_lab.metric_basis.marketing.short_label", {defaultValue: "Bez storen"}),
            help: t("reporting_lab.metrics_help.marketing_pno", {defaultValue: "PNO = veškeré marketingové náklady za zvolené období a filtry / obrat nestornovaných objednávek × 100%. Náklady se nevylučují podle stavu objednávek."}),
        };
    }

    return {
        short: t("project.campaign_comparison_basis_net_short"),
        help: t("project.campaign_comparison_basis_net_help"),
    };
}

export default function CampaignOrderBasis({isMarketing}) {
    const {t} = useTranslation();
    const copy = campaignOrderBasisCopy(t, isMarketing);

    return <div className="flex items-center gap-2">
        <span className="text-xs font-normal text-slate-500 dark:text-slate-400">
            {copy.short}
        </span>
        <ReportingInfoTooltip position="bottom">
            {copy.help}
        </ReportingInfoTooltip>
    </div>;
}
